import React, { useEffect, useState } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { vendorOptions } from "../../../services/vendor.services";
import {
  addOrder,
  editOrder,
  deleteOrder,
  orderDetails,
  listOrder,
  productOption,
} from "../../../services/order-management.service";
import {
  LOADER_TIMEOUT_TIME,
  ORDER_MANAGEMENT_STATUS,
  PAYMENT_OPTIONS,
  PAYMENT_STATUS,
  SORT_A,
  SORT_D,
  SWAL_SETTINGS,
} from "../../../../../utils/Constants";

import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import {
  capitalizeFirstLetter,
  formateDate,
  globalLoader,
  handleOffcanvasScroll,
  handleServerValidations,
  RSUITE_DATE_FORMAT,
  useDebouncing,
  writeMyExcel,
} from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import RecordNotFound from "../../../shared/recordNotFound";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../../admin/common/custompagination";
import logo from "../../../../../assets/restaurant/images/calenderLogo.png";
import { DatePicker, Drawer } from "rsuite";
import isBefore from "date-fns/isBefore";
import {
  addPayment,
  paymentOrderOption,
  paymentVendorOption,
} from "../../../services/payment-managament.service";
import ManagementToolbar from "../../../shared/components/ManagementToolbar";
import ResponsiveDataTable from "../../../shared/components/ResponsiveDataTable";
import TableActionDropdown from "../../../shared/components/TableActionDropdown";

const CustomBase64Caret = () => (
  <img src={logo} alt="Custom Caret" style={{ width: 20, height: 20 }} />
);

export default function OrderManagement() {
  const [filters, setFilters] = useState({
    payment_status: "",
    delivery_status: "",
  });
  const [details, setDetails] = useState(null);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const itemPerPage = 10;
  const { t } = useTranslation();
  const [List, setList] = useState([]);
  const { editOrderValidationSchema, addOrderValidationSchema } =
    useValidationSchemas();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);

  // ✅ Payment Registration Drawer state
  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
  const [paymentVendorOptions, setPaymentVendorOptions] = useState([]);
  const [orderOptionList, setOrderOptionList] = useState([]);
  const [productOptionList, setProductOptionList] = useState([]);
  const [addPaymentLoader, setAddPaymentLoader] = useState(false);
  const [isOrderPrefilled, setIsOrderPrefilled] = useState(false);

  const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [vendorOptionsList, setVendorOptionsList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortConfig, setSortConfig] = useState({
    column: "createdAt",
    order: SORT_D,
  });
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(true);

  const MAX_QUANTITY = 100000;
  const MAX_AMOUNT = 100000;



  const prepareGlobalSearch = (value) => {
    setPrevGlobalSearch(globalSearch);
    setGlobalSearch(value);
    setPage(1);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch, 500);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    searchDebounce(value);
  };

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== "")
    );
    if (Object.keys(cleanedFilters).length) {
      formData.append("search", JSON.stringify(cleanedFilters));
    }
    formData.append("global_search", globalSearch);
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    if (sortConfig) formData.append("sort", JSON.stringify(sortConfig));

    listOrder(formData)
      .then((response) => {
        if (response?.data) {
          setList(response.data.list || []);
          setOffsetPage(response.data.offset || 0);
          setTotalRecords(response.data.total_records || 0);
        } else {
          setList([]);
          setOffsetPage(0);
          setTotalRecords(0);
        }
        setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.log("Order list error ====> ", error);
        setLoader(false);
      });
  }, [page, globalSearch, sortConfig, refreshList, search, filters]);

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  // ✅ Fetch vendor options for order form
  useEffect(() => {
    vendorOptions()
      .then((response) => setVendorOptionsList(response?.data || []))
      .catch((err) => console.error(err));
  }, []);

  // ✅ Fetch order options for payment form
  useEffect(() => {
    const formData = new FormData();
    paymentOrderOption(formData)
      .then((response) => {
        if (response?.data) setOrderOptionList(response?.data?.list || []);
      })
      .catch((error) => console.log("Order options error ====> ", error));
  }, []);

  // ✅ Fetch product options for order form
  useEffect(() => {
    productOption()
      .then((response) => {
        if (response?.data) setProductOptionList(response?.data || []);
      })
      .catch((error) => console.log("Product options error ====> ", error));
  }, []);

  const handleSort = (key) => {
    let direction = SORT_A;
    if (sortConfig.column === key && sortConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortConfig({ column: key, order: direction });
  };

  const handleViewDetails = async (item) => {
    try {
      setDetailsLoading(true);
      const response = await orderDetails({ o_id: item._id });
      if (response.success) {
        setDetails(response?.data);
      } else {
        alert(response?.message || "Something went wrong");
      }
      setDetailsLoading(false);
    } catch (err) {
      console.error(err);
      setDetailsLoading(false);
    }
  };

  const handleEditDetails = async (item) => {
    try {
      setDetailsLoading(true);
      const response = await orderDetails({ o_id: item._id });
      if (response.success) {
        const data = response?.data;
        editForm.setValues({
          order_id: data?._id || "",
          vendor_id: data?.vendorData?._id || "",
          order_date: data?.order_date || "",
          order_amount:
            data?.order_amount != null
              ? Number(data.order_amount).toFixed(2)
              : "",
          payment_status: data?.payment_status || "",
          delivery_status: data?.delivery_status || "",
          products: data?.products || [
            { product_name: "", unit: "KG", quantity: "" },
          ],
        });
      }
      setDetailsLoading(false);
    } catch (err) {
      console.error(err);
      setDetailsLoading(false);
    }
  };

  // ✅ "Create Transaction" click handler — pre-fill payment form with order data
  const createTransactionHandle = async (item) => {
    try {
      // 1. Pehle fresh order options fetch karo (race condition fix)
      const orderFormData = new FormData();
      const orderRes = await paymentOrderOption(orderFormData);
      if (orderRes?.data) {
        setOrderOptionList(orderRes?.data?.list || []);
      }

      // 2. Vendor info fetch karo is order ke liye
      const vendorFormData = new FormData();
      vendorFormData.append("order_id", item._id);
      const vendorRes = await paymentVendorOption(vendorFormData);
      const vendors = Array.isArray(vendorRes.data)
        ? vendorRes.data
        : [vendorRes.data];
      setPaymentVendorOptions(vendors);

      // 3. Ab form mein values set karo — sab data ready hai
      paymentForm.setValues({
        vendor_id: vendors.length > 0 ? vendors[0].vendor_id?.toString() : "",
        order_id: item._id,
        payment_date: "",
        payment_amount: vendors.length > 0 ? vendors[0].order_amount || "" : "",
        content_and_notes: "",
        payment_method: "",
        payment_status: "",
      });

      setIsOrderPrefilled(true);
      setOpenPaymentDrawer(true);
    } catch (error) {
      console.error("createTransactionHandle error:", error);
    }
  };

  const deleteOrderRecord = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteOrder({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
              setOpenWithHeader(false);
              setPage(1);
              setSortConfig({ column: "createdAt", order: SORT_D });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteOrderError", error);
          });
      }
    });
  };

  // ✅ Helper: quantity onChange handler with max cap (1 lakh)
  const handleQuantityChange = (e, form, fieldName) => {
    let val = e.target.value;
    if (val === "") {
      form.setFieldValue(fieldName, "");
      return;
    }
    val = parseInt(val, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > MAX_QUANTITY) val = MAX_QUANTITY;
    form.setFieldValue(fieldName, val);
  };

  // ✅ Helper: amount onChange handler with max cap (1 lakh)
  const handleAmountChange = (e, form) => {
    let val = e.target.value;
    if (/^\d*$/.test(val)) {
      if (val !== "" && parseInt(val, 10) > MAX_AMOUNT) {
        val = String(MAX_AMOUNT);
      }
      form.setFieldValue("order_amount", val);
    }
  };

  const addForm = useFormik({
    initialValues: {
      vendor_id: "",
      order_date: "",
      payment_status: "",
      delivery_status: "",
      order_amount: "",
      products: [{ product_name: "", unit: "KG", quantity: "" }],
    },
    validationSchema: addOrderValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, { resetForm }) => {
      setAddSubmissionLoader(true);
      addOrder(values)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            resetForm();
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error adding order", error);
        });
    },
  });

  const editForm = useFormik({
    initialValues: {
      order_id: "",
      vendor_id: "",
      order_date: "",
      payment_status: "",
      delivery_status: "",
      order_amount: "",
      products: [{ product_name: "", unit: "KG", quantity: "" }],
    },
    validationSchema: editOrderValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      setAddSubmissionLoader(true);
      editOrder(values)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            resetForm();
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => console.error("Error updating order", error));
    },
  });

  // ✅ Payment Registration Form (same as PaymentManagement)
  const addPaymentValidationSchema = Yup.object().shape({
    order_id: Yup.string().required("Order is required"),
    payment_date: Yup.date().required("Payment date is required"),
    payment_method: Yup.string().required("Payment method is required"),
    payment_status: Yup.string().required("Payment status is required"),
  });

  const paymentForm = useFormik({
    initialValues: {
      vendor_id: "",
      order_id: "",
      payment_date: "",
      payment_amount: "",
      content_and_notes: "",
      payment_method: "",
      payment_status: "",
    },
    validationSchema: addPaymentValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("vender_id", values.vendor_id);
      formData.append("order_id", values.order_id);
      formData.append("payment_date", values.payment_date);
      formData.append("payment_amount", values.payment_amount);
      formData.append("content_and_notes", values.content_and_notes);
      formData.append("payment_method", values.payment_method);
      formData.append("payment_status", values.payment_status);
      setAddPaymentLoader(true);
      addPayment(formData)
        .then((response) => {
          setAddPaymentLoader(false);
          if (response.success) {
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            resetForm();
            setPaymentVendorOptions([]);
            setOpenPaymentDrawer(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddPaymentLoader(false);
          console.error("Error adding payment", error);
        });
    },
  });

  const vendorOptionHandler = (orderId) => {
    const formData = new FormData();
    formData.append("order_id", orderId);
    paymentVendorOption(formData)
      .then((response) => {
        const vendors = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setPaymentVendorOptions(vendors);
        if (vendors.length > 0) {
          paymentForm.setFieldValue("vendor_id", vendors[0].vendor_id?.toString());
          paymentForm.setFieldValue("payment_amount", vendors[0].order_amount || "");
        }
      })
      .catch((error) => console.error("Error fetching vendor options:", error));
  };

  const formatPaymentLabel = (value) => {
    if (!value) return "";
    if (value.toLowerCase() === "upi") return "UPI";
    return value
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  console.log("list", List);

  const handleOrderExportToExcel = () => {
    if (!List || List.length === 0) return;
    const headers = [
      t("label_order_date"),
      t("label_company_name"),
      t("label_total_product"),
      t("label_order_amount"),
      t("label_payment_status"),
      t("label_delivery_status"),
    ];
    const rows = List.map((item) => [
      item?.order_date ? formateDate(item.order_date) : "-",
      item?.vendorData?.companyName || "-",
      item?.total_products ? item?.total_products : "-",
      item?.order_amount || "-",
      item?.payment_status === "paid"
        ? t("label_order_payment_status_paid")
        : t("label_order_payment_status_unpaid"),
      item?.delivery_status === "ordered"
        ? t("label_order_delivery_status_ordered")
        : item?.delivery_status === "delivered"
          ? t("label_order_delivery_status_delivered")
          : t("label_order_delivery_status_pending"),
    ]);
    writeMyExcel([headers, ...rows], `${t("label_order_list")}.xlsx`);
  };

  const formatOrderId = (id) => {
    if (!id) return "-";
    const lastSix = id.slice(-6);
    return parseInt(lastSix, 16);
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">
            {t("label_order_management")} ({totalRecords})
          </h4>
        </div>
        <ManagementToolbar search={<div className="search-box">
            <input
              type="text"
              value={searchValue}
              className="form-control search-input"
              placeholder={t("input_placeholder_search")}
              onChange={handleSearchChange}
            />
          </div>}>
            {/* Payment filter */}
            <div className="tabls-dowpdown">
              <select
                className="form-control cp"
                name="payment_status"
                value={filters.payment_status}
                onChange={handleFilterChange}
              >
                <option value="">{t("label_payment_status")}</option>
                <option value="paid">{t("label_order_payment_status_paid")}</option>
                <option value="unpaid">{t("label_order_payment_status_unpaid")}</option>
              </select>
            </div>
            {/* Delivery filter */}
            <div className="tabls-dowpdown">
              <select
                className="form-control cp"
                name="delivery_status"
                value={filters.delivery_status}
                onChange={handleFilterChange}
              >
                <option value="">{t("label_delivery_status")}</option>
                <option value="delivered">{t("label_order_delivery_status_delivered")}</option>
                <option value="pending">{t("label_order_delivery_status_pending")}</option>
              </select>
            </div>

            <button className="btn btn-primary" onClick={() => setOpenWithHeader(true)}>
              <i className="ti ti-plus"></i> {t("label_make_order")}
            </button>
            <button
              className="btn btn-primary"
              style={{ whiteSpace: "nowrap" }}
              onClick={handleOrderExportToExcel}
              disabled={!List || List.length === 0}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H11.5M14 3L19 8M19 8V13M14 19H21M21 19L18 16M21 19L18 22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>{" "}
              {t("label_export")}
            </button>
        </ManagementToolbar>
        <div className="page-header d-flex align-items-center">
          <h6 className="heading-title-text">{t("label_order_list")}</h6>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : List?.length ? (
              <div className="card">
                <div className="card-body">
                  <ResponsiveDataTable>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            {t("label_order_id")}
                            <span style={{ cursor: "pointer" }} onClick={() => handleSort("orderId")}>
                              <i className={`${sortConfig.column === "orderId" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`} style={{ marginLeft: "5px" }}></i>
                              <i className={`${sortConfig.column === "orderId" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`} style={{ marginLeft: "-8px" }}></i>
                            </span>
                          </th>
                          <th>
                            {t("label_order_date")}
                            <span style={{ cursor: "pointer" }} onClick={() => handleSort("orderDate")}>
                              <i className={`${sortConfig.column === "orderDate" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`} style={{ marginLeft: "5px" }}></i>
                              <i className={`${sortConfig.column === "orderDate" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`} style={{ marginLeft: "-8px" }}></i>
                            </span>
                          </th>
                          <th>
                            {t("label_company_name")}
                            <span style={{ cursor: "pointer" }} onClick={() => handleSort("companyName")}>
                              <i className={`${sortConfig.column === "companyName" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`} style={{ marginLeft: "5px" }}></i>
                              <i className={`${sortConfig.column === "companyName" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`} style={{ marginLeft: "-8px" }}></i>
                            </span>
                          </th>
                          <th>{t("label_total_products")}</th>
                          <th>{t("label_amount")}</th>
                          <th>{t("label_payment_status")}</th>
                          <th>{t("label_delivery_status")}</th>
                          <th style={{ width: "150px" }}>{t("label_operate")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {List.map((item) => (
                          <tr key={item._id}>
                            <td>#{`${formatOrderId(item._id)}`}</td>
                            <td className="text-capitalize">
                              {item?.createdAt
                                ? formateDate(item.order_date)
                                : "-"}
                            </td>
                            <td>{capitalizeFirstLetter(item?.vendorData?.companyName) || "-"}</td>
                            <td>{item?.total_products || 0}</td>

                            <td>
                              ¥{item?.order_amount != null
                                ? Number(item.order_amount) % 1 === 0
                                  ? item.order_amount
                                  : Number(item.order_amount).toFixed(2)
                                : 0}

                            </td>
                            <td>
                              {item?.payment_status === "paid" ? (
                                <span className="status-badge d-block status-badge-success" style={{ width: "max-content" }}>
                                  {t("label_paid")}
                                </span>
                              ) : (
                                <span className="status-badge d-block status-badge-danger" style={{ width: "max-content" }}>
                                  {t("label_unpaid")}
                                </span>
                              )}
                            </td>
                            <td>
                              {(function () {
                                if (item?.delivery_status === ORDER_MANAGEMENT_STATUS.DELEVERED) {
                                  return (
                                    <span className="status-badge d-block status-badge-success" style={{ width: "max-content" }}>
                                      Delivered
                                    </span>
                                  );
                                } else if (item?.delivery_status === ORDER_MANAGEMENT_STATUS.PENDING) {
                                  return (
                                    <span className="status-badge d-block status-badge-danger" style={{ width: "max-content" }}>
                                      Pending
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span className="status-badge d-block status-badge-info" style={{ width: "max-content" }}>
                                      Unknown
                                    </span>
                                  );
                                }
                              })()}
                            </td>
                            <td className="">
                              <TableActionDropdown>
                                  {/* View */}
                                  <li>
                                    <a
                                      className="dropdown-item cp"
                                      onClick={() => handleViewDetails(item)}
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#view-staff"
                                    >
                                      <i className="ti ti-eye"></i>
                                      {t("btn_view")}
                                    </a>
                                  </li>
                                  {/* Edit */}
                                  <li>
                                    <a
                                      className="dropdown-item cp"
                                      onClick={() => {
                                        handleEditDetails(item);
                                        setOpenWithHeaderEdit(true);
                                      }}
                                    >
                                      <i className="ti ti-edit"></i>
                                      {t("btn_edit")}
                                    </a>
                                  </li>
                                  {/* Delete */}
                                  <li>
                                    <a
                                      className="dropdown-item cp text-danger"
                                      onClick={() => deleteOrderRecord(item)}
                                    >
                                      <i className="ti ti-trash"></i>
                                      {t("btn_delete")}
                                    </a>
                                  </li>
                                  {/* ✅ Create Transaction — opens Payment Registration Drawer */}
                                  <li>
                                    <a
                                      className="dropdown-item cp"
                                      onClick={() => createTransactionHandle(item)}
                                    >
                                      <i className="ti ti-plus"></i>
                                      {t("btn_create_transaction")}
                                    </a>
                                  </li>
                              </TableActionDropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </ResponsiveDataTable>
                  <div className="table-status-info d-flex justify-content-between align-items-center">
                    <span>
                      {t("label_showing_entries", { shown: offset + List.length, total: totalRecords })}
                    </span>
                    <nav aria-label="Page navigation example" title={page}>
                      {totalRecords > itemPerPage ? (
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[
                            { name: "vendors", path: "/restaurant/order-management/order-management/list" },
                          ]}
                        />
                      ) : ""}
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_order_found" />
            )}
          </div>
        </div>
      </div>

      {/* ===================== ADD ORDER DRAWER ===================== */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_order_registration")}</h5>
            <button className="btn-icon" onClick={() => { setOpenWithHeader(false); addForm.resetForm(); }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body onScroll={(e) => handleOffcanvasScroll(e, "editNewEmail", "rsuite")}>
          <form onSubmit={addForm.handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">{t("label_order_vendor")}<span>*</span></label>
              <select className="form-control" name="vendor_id" value={addForm?.values?.vendor_id} onChange={addForm.handleChange} onBlur={addForm.handleBlur}>
                <option value="">{t("input_select_text")}</option>
                {vendorOptionsList?.map((vendor) => (
                  <option key={vendor._id} value={vendor._id}>{vendor.companyName}</option>
                ))}
              </select>
              <CustomError name="vendor_id" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_order_date")}<span>*</span></label>
              <DatePicker
                oneTap={true} classPrefix="restaurant" placeholder={t("label_select_date")}
                placement="autoVertical" format={RSUITE_DATE_FORMAT} cleanable={false} editable={false}
                name="order_date"
                onChange={(e) => { addForm.setFieldTouched("order_date", true); addForm.setFieldValue("order_date", e); }}
                value={addForm.values.order_date ? new Date(addForm.values.order_date) : null}
                onBlur={addForm.handleBlur} caretAs={CustomBase64Caret}
              />
              <CustomError name="order_date" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label fs-4 fw-bold">{t("label_order_product")}</label>
              <div className="row mb-2">
                <div className="col-md-5"><small className="form-label">{t("label_order_product_name")}</small></div>
                <div className="col-md-3"><small className="form-label">{t("label_unit")}</small></div>
                <div className="col-md-3"><small className="form-label">{t("label_order_qty")}</small></div>
              </div>
              {addForm.values.products?.map((product, index) => (
                <div key={index} className="row mb-2 align-items-start">
                  <div className="col-md-5">
                    <select
                      className="form-control"
                      name={`products.${index}.product_name`}
                      value={product.product_name || product.productname || ''}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    >
                      <option value="">{t("input_select_text")}</option>
                      {productOptionList?.map((prod) => (
                        <option key={prod._id} value={prod.name}>
                          {prod.name}
                        </option>
                      ))}
                    </select>
                    <CustomError name={`products.${index}.product_name`} form={addForm} className="text-danger" />
                  </div>
                  <div className="col-md-3">
                    <select className="form-control" name={`products.${index}.unit`} value={product.unit} onChange={addForm.handleChange}>
                      <option value="kg">KG</option>
                      <option value="ltr">LTR</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    {/* ✅ Quantity: max 1 lakh (100000) */}
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("label_order_qty")}
                      name={`products.${index}.quantity`}
                      value={product.quantity}
                      onChange={(e) => handleQuantityChange(e, addForm, `products.${index}.quantity`)}
                      onBlur={addForm.handleBlur}
                      onKeyDown={(e) => { if (e.key === "." || e.key === "-" || e.key === "e") e.preventDefault(); }}
                      min={1}
                      max={MAX_QUANTITY}
                    />
                    <CustomError name={`products.${index}.quantity`} form={addForm} className="text-danger" />
                  </div>
                  <div className="col-1 p-0">
                    {index > 0 && (
                      <button type="button" className="btn btn-sm btn btn-primary text-white px-2"
                        onClick={() => { const updated = [...addForm.values.products]; updated.splice(index, 1); addForm.setFieldValue("products", updated); }}>
                        <i className="ri-close-large-line"></i>
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <span className="link-text text-decoration-none cp"
                onClick={() => addForm.setFieldValue("products", [...addForm.values.products, { product_name: "", unit: "KG", quantity: "" }])}>
                + {t("label_order_add_more")}
              </span>
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_order_amount")}<span>*</span></label>
              {/* ✅ Amount: max 1 lakh (100000) */}
              <input
                type="number"
                className="form-control"
                placeholder={t("label_order_amount")}
                name="order_amount"
                value={addForm?.values?.order_amount}
                onChange={(e) => handleAmountChange(e, addForm)}
                onKeyDown={(e) => { if (e.key === "." || e.key === "-" || e.key === "e") e.preventDefault(); }}
                onBlur={addForm.handleBlur}
                min={1}
                max={MAX_AMOUNT}
              />
              <CustomError name="order_amount" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_order_status")}<span>*</span></label>
              <select className="form-control" name="delivery_status" value={addForm?.values?.delivery_status} onChange={addForm.handleChange} onBlur={addForm.handleBlur}>
                <option value="">{t("input_select_text")}</option>
                <option value="delivered">{t("label_order_delivery_status_delivered")}</option>
                <option value="pending">{t("label_order_delivery_status_pending")}</option>
              </select>
              <CustomError name="delivery_status" form={addForm} className="text-danger" />
            </div>

            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                {t("label_vendor_save")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* ===================== EDIT ORDER DRAWER ===================== */}
      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("edit_order")}</h5>
            <button className="btn-icon" onClick={() => { setOpenWithHeaderEdit(false); editForm.resetForm(); }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          {detailsLoading ? (
            <Skeleton className="mb-2" height={30} count={5} />
          ) : (
            <form onSubmit={editForm.handleSubmit}>
              <div className="mb-3">
                <label className="form-label">{t("label_order_vendor")}<span>*</span></label>
                <select className="form-control" name="vendor_id" value={editForm?.values?.vendor_id} onChange={editForm.handleChange} onBlur={editForm.handleBlur}>
                  <option value="">{t("input_select_text")}</option>
                  {vendorOptionsList?.map((vendor) => (
                    <option key={vendor._id} value={vendor._id}>{vendor.companyName}</option>
                  ))}
                </select>
                <CustomError name="vendor_id" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_order_date")}<span>*</span></label>
                <DatePicker
                  oneTap={true} classPrefix="restaurant" placeholder={t("placeholder_date")}
                  placement="autoVertical" format={RSUITE_DATE_FORMAT} cleanable={false} editable={false}
                  name="order_date"
                  shouldDisableDate={(date) => isBefore(date, new Date(yesterday))}
                  onChange={(e) => { editForm.setFieldTouched("order_date", true); editForm.setFieldValue("order_date", e); }}
                  value={new Date(editForm.values.order_date)}
                  onBlur={editForm.handleBlur} caretAs={CustomBase64Caret}
                />
                <CustomError name="order_date" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label fs-4 fw-bold">{t("label_order_product")}</label>
                <div className="row mb-2">
                  <div className="col-md-5"><small className="form-label">{t("label_order_product_name")}</small></div>
                  <div className="col-md-3"><small className="form-label">{t("label_unit")}</small></div>
                  <div className="col-md-3"><small className="form-label">{t("label_order_qty")}</small></div>
                </div>
                {editForm.values.products?.map((product, index) => (
                  <div key={index} className="row mb-2 align-items-start">
                    <div className="col-md-5">
                      <select
                        className="form-control"
                        name={`products[${index}].product_name`}
                        value={product.product_name}
                        onChange={editForm.handleChange}
                        onBlur={editForm.handleBlur}
                      >
                        <option value="">{t("input_select_text")}</option>
                        {productOptionList?.map((prod) => (
                          <option key={prod._id} value={prod.name}>
                            {prod.name}
                          </option>
                        ))}
                      </select>
                      <CustomError name={`products[${index}].product_name`} form={editForm} className="text-danger" />
                    </div>
                    <div className="col-md-3">
                      <select className="form-control" name={`products[${index}].unit`} value={product.unit} onChange={editForm.handleChange}>
                        <option value="kg">KG</option>
                        <option value="ltr">LTR</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      {/* ✅ Quantity: max 1 lakh (100000) */}
                      <input
                        type="number"
                        className="form-control"
                        placeholder={t("label_order_qty")}
                        name={`products[${index}].quantity`}
                        value={product.quantity}
                        onChange={(e) => handleQuantityChange(e, editForm, `products[${index}].quantity`)}
                        onBlur={editForm.handleBlur}
                        onKeyDown={(e) => { if (e.key === "." || e.key === "-" || e.key === "e") e.preventDefault(); }}
                        min={1}
                        max={MAX_QUANTITY}
                      />
                      <CustomError name={`products[${index}].quantity`} form={editForm} className="text-danger" />
                    </div>
                    <div className="col-1 p-0">
                      {index > 0 && (
                        <button type="button" className="btn btn-sm btn btn-primary text-white px-2"
                          onClick={() => { const updated = [...editForm.values.products]; updated.splice(index, 1); editForm.setFieldValue("products", updated); }}>
                          <i className="ri-close-large-line"></i>
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                <span className="link-text text-decoration-none cp"
                  onClick={() => editForm.setFieldValue("products", [...editForm.values.products, { product_name: "", unit: "KG", quantity: "" }])}>
                  + {t("label_order_add_more")}
                </span>
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_order_delivery_status")}<span>*</span></label>
                <select className="form-control" name="delivery_status" value={editForm?.values?.delivery_status} onChange={editForm.handleChange} onBlur={editForm.handleBlur}>
                  <option value="">{t("input_select_text")}</option>
                  <option value="delivered">{t("label_order_delivery_status_delivered")}</option>
                  <option value="pending">{t("label_order_delivery_status_pending")}</option>
                </select>
                <CustomError name="delivery_status" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_order_amount")}<span>*</span></label>
                {/* ✅ Amount: max 1 lakh (100000) */}
                <input
                  type="number"
                  className="form-control"
                  placeholder={t("label_order_amount")}
                  name="order_amount"
                  value={editForm?.values?.order_amount}
                  onChange={(e) => handleAmountChange(e, editForm)}
                  onKeyDown={(e) => { if (e.key === "." || e.key === "-" || e.key === "e") e.preventDefault(); }}
                  onBlur={editForm.handleBlur}
                  min={1}
                  max={MAX_AMOUNT}
                />
                <CustomError name="order_amount" form={editForm} className="text-danger" />
              </div>

              <div className="button-form">
                <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                  {t("btn_text_update")}
                </button>
              </div>
            </form>
          )}
        </Drawer.Body>
      </Drawer>

      {/* ===================== ✅ PAYMENT REGISTRATION DRAWER ===================== */}
      <Drawer open={openPaymentDrawer}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_payment_registration")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenPaymentDrawer(false);
                paymentForm.resetForm();
                setPaymentVendorOptions([]);
                setIsOrderPrefilled(false);
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body onScroll={(e) => handleOffcanvasScroll(e, "editNewEmail", "rsuite")}>
          <form onSubmit={paymentForm.handleSubmit}>

            {/* Vendor (auto-filled, disabled) */}
            <div className="mb-3">
              <label className="form-label">{t("label_order_vendor")}</label>
              <select
                className="form-control"
                name="vendor_id"
                value={paymentForm.values.vendor_id}
                onChange={paymentForm.handleChange}
                onBlur={paymentForm.handleBlur}
                disabled
              >
                <option value="">{t("input_select_vender_a_text")}</option>
                {Array.isArray(paymentVendorOptions) && paymentVendorOptions.length > 0 ? (
                  paymentVendorOptions.map((vendor) => (
                    <option key={vendor.vendor_id} value={vendor.vendor_id}>
                      {vendor.companyName}
                    </option>
                  ))
                ) : (
                  <option>{t("no_vendors_found")}</option>
                )}
              </select>
            </div>

            {/* Order (auto-filled, but changeable) */}
            <div className="mb-3">
              <label className="form-label">{t("label_order")}</label>
              <select
                className="form-control"
                name="order_id"
                value={paymentForm.values.order_id}
                onChange={(e) => {
                  vendorOptionHandler(e.target.value);
                  paymentForm.handleChange(e);
                }}
                onBlur={paymentForm.handleBlur}
                disabled={isOrderPrefilled}
                style={isOrderPrefilled ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : {}}
              >
                <option value="">{t("placeholder_select")}</option>
                {orderOptionList?.map((order) => (
                  <option key={order._id} value={order._id}>
                    {`${formatOrderId(order._id)}`}
                  </option>
                ))}
              </select>
              <CustomError name="order_id" form={paymentForm} className="text-danger" />
            </div>

            {/* Payment Date */}
            <div className="mb-3">
              <label className="form-label">{t("label_payment_date")}</label>
              <DatePicker
                oneTap={true} classPrefix="restaurant" placeholder={t("placeholder_select")}
                placement="autoVertical" format={RSUITE_DATE_FORMAT} cleanable={false} editable={false}
                name="payment_date"
                onChange={(e) => { paymentForm.setFieldTouched("payment_date", true); paymentForm.setFieldValue("payment_date", e); }}
                value={paymentForm.values.payment_date ? new Date(paymentForm.values.payment_date) : null}
                onBlur={paymentForm.handleBlur} caretAs={CustomBase64Caret}
              />
              <CustomError name="payment_date" form={paymentForm} className="text-danger" />
            </div>

            {/* Payment Amount (auto-filled, disabled) */}
            <div className="mb-3">
              <label className="form-label">{t("label_payment_amount")}</label>
              <input
                type="number" className="form-control" placeholder={t("label_payment_amount")}
                name="payment_amount" value={paymentForm.values.payment_amount}
                onChange={paymentForm.handleChange} onBlur={paymentForm.handleBlur}
                disabled style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
              />
            </div>

            {/* Content & Notes */}
            <div className="mb-3">
              <label className="form-label">{t("label_content_and_notes")}</label>
              <textarea
                className="form-control" style={{ height: "120px" }} rows="3"
                name="content_and_notes" value={paymentForm.values.content_and_notes}
                onChange={paymentForm.handleChange} onBlur={paymentForm.handleBlur}
              />
              <CustomError name="content_and_notes" form={paymentForm} className="text-danger" />
            </div>

            {/* Payment Method */}
            <div className="mb-3">
              <label className="form-label">{t("label_payment_method")}</label>
              <select
                className="form-control" name="payment_method"
                value={paymentForm.values.payment_method}
                onChange={paymentForm.handleChange} onBlur={paymentForm.handleBlur}
              >
                <option value="">{t("placeholder_select")}</option>
                {Object.values(PAYMENT_OPTIONS)?.map((data) => (
                  <option key={data} value={data}>{formatPaymentLabel(data)}</option>
                ))}
              </select>
              <CustomError name="payment_method" form={paymentForm} className="text-danger" />
            </div>

            {/* Payment Status */}
            <div className="mb-3">
              <label className="form-label">{t("label_payment_status")}</label>
              <select
                className="form-control" name="payment_status"
                value={paymentForm.values.payment_status}
                onChange={paymentForm.handleChange} onBlur={paymentForm.handleBlur}
              >
                <option value="">{t("placeholder_select")}</option>
                {Object.values(PAYMENT_STATUS)?.map((data) => (
                  <option key={data} value={data}>{capitalizeFirstLetter(data)}</option>
                ))}
              </select>
              <CustomError name="payment_status" form={paymentForm} className="text-danger" />
            </div>

            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (addPaymentLoader ? " btn-loader" : "")}>
                {t("label_vendor_save")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* ===================== VIEW ORDER OFFCANVAS ===================== */}
      <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static"
        tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">{t("order_details")}</h5>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          {detailsLoading ? (
            <Skeleton className="mb-2" height={30} count={5} />
          ) : (
            <div className="view-staff-info">
              <div className="row gap-4">
                <div className="col-md-12">
                  <h4>{t("label_order_id")}</h4>
                  <p>{details?._id ? `#${formatOrderId(details._id)}` : t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_order_vendor")}</h4>
                  <p>{details?.vendorData?.companyName ? details.vendorData.companyName : t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_order_date")}</h4>
                  <p>{details?.createdAt ? formateDate(details.createdAt) : t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_total_products")}</h4>
                  {details?.products?.length > 0 ? (
                    <div className="border rounded p-3" style={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>
                      {details.products.map((product) => (
                        <div key={product._id} className="d-flex justify-content-between mb-2 gap-3" style={{ wordBreak: "break-word" }}>
                          <span style={{ flex: 1 }}>{product.product_name}</span>
                          <span style={{ whiteSpace: "nowrap" }}>{product.quantity} {product.unit}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>{t("label_not_entered")}</p>
                  )}
                </div>
                <div className="col-md-12">
                  <h4>{t("label_amount")}</h4>
                  <p>¥{details?.order_amount || 0}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_payment_status")}</h4>
                  <p className="text-capitalize">{details?.payment_status || "-"}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_delivery_status")}</h4>
                  <p className="text-capitalize">{details?.delivery_status || "-"}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
